module.exports = __webpack_public_path__ + "static/media/card-briales.828755ae.png";